import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { Check } from 'lucide-react';
import clsx from 'clsx';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> {
  label?: ReactNode;
  /** Smaller variant — for table rows. */
  size?: 'sm' | 'md';
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, size = 'md', className, disabled, checked, ...rest },
  ref,
) {
  return (
    <label className={clsx(styles.wrapper, disabled && styles.disabled, className)}>
      <span className={clsx(styles.box, styles[`size_${size}`], checked && styles.checked)}>
        <input
          ref={ref}
          type="checkbox"
          className={styles.input}
          disabled={disabled}
          checked={checked}
          {...rest}
        />
        {checked && <Check size={size === 'sm' ? 10 : 12} strokeWidth={3} aria-hidden="true" />}
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
});
